import React, { useEffect, useState } from "react";

export const CheckoutButton = (props) => {

  const [country, setCountry] = useState("");
  useEffect(() => {
    const countryField = document.querySelector("#billing-country input");

    if (countryField) {
      countryField.addEventListener("input", handleCountryChange);
      countryField.addEventListener("blur", handleCountryChange);
    }
  }, []);

  useEffect(() => {
    document.body.dispatchEvent(new Event("update_checkout"));
  }, [country]);


  const handleCountryChange = (event) => {
    setCountry(event.target.value);
  };

  return <> </>;
};

export const AliasPopup = (props) => {
  const { onPaymentSetup, emitResponse } = props;
  const [shouldSavePaymentMethod, setShouldSavePaymentMethod] = useState(false);

  useEffect(() => {
    const radios = document.querySelectorAll('input[name="radio-control-wc-payment-method-options"]');
    if (radios !== null) {
      radios.forEach((radio) => {
        if (radio.checked) {
          const label = radio.parentNode.parentNode;
          let saveCardChecked = label.getAttribute('data-save-card-checked');
          const saferpayAliasDiv = label.querySelector(".spgw-saferpay-alias");
          if (saveCardChecked === 'checked') {
            saferpayAliasDiv.style.display = "none";
            setShouldSavePaymentMethod(true);
          } else if (saveCardChecked === 'unchecked') {
            saferpayAliasDiv.style.display = "block";
            const select = saferpayAliasDiv.querySelector("select");
            const newOption = select.querySelector("option[value='new']");
            select.selectedIndex = Array.prototype.indexOf.call(select.options, newOption);
          }

          const saferpaySelectValue = label.getAttribute('data-select-value');

          if (saferpaySelectValue !== null) {
            const saferpayselect = saferpayAliasDiv.querySelector('select');
            const saferpayDiv = document.getElementById('saferpay-div');
            const selectElements = document.querySelector('.woocommerce-SavedPaymentMethods-saveNew');
            const saveCardElements = document.querySelector('.wc-block-components-payment-methods__save-card-info');
            if (saferpaySelectValue === "new") {

              if (saferpayDiv !== null) {
                saferpayDiv.style.display = 'block';
              }

              if (selectElements !== null) {
                saferpayselect.parentNode.querySelector('.woocommerce-SavedPaymentMethods-saveNew').style.display = 'block';
              } else if (saveCardElements !== null) {
                saferpayselect.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.wc-block-components-payment-methods__save-card-info').style.display = 'block';
              }
            } else {
              if (saferpayDiv !== null) {
                saferpayDiv.style.display = 'none';
              }
              if (selectElements !== null) {
                saferpayselect.parentNode.querySelector('.woocommerce-SavedPaymentMethods-saveNew').style.display = 'none';
              } else if (saveCardElements !== null) {
                saferpayselect.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.wc-block-components-payment-methods__save-card-info').style.display = 'none';
              }
            }
            saferpayselect.value = saferpaySelectValue;
          }

        }
      });
    }


  }, []);

  useEffect(() => {
    window.wp.data.dispatch('wc/store/payment').__internalSetShouldSavePaymentMethod(shouldSavePaymentMethod);
  }, [shouldSavePaymentMethod]);

  useEffect(() => {
    const unsubscribe = onPaymentSetup(async () => {
      // Here we can do any processing we need, and then emit a response.
      // For example, we might validate a custom field, or perform an AJAX request, and then emit a response indicating it is valid or not.
      const fromCheckoutBlock = "yes";
      const token = typeof SaferpayFields != 'undefined' ? SaferpayFields.token : "";
      const customDataIsValid = !!token;
      const paymentType = document.querySelector(
        "[name^='spgw_saferpay_alias_']"
      );
      let paymentAlias = "";

      const payloads = {

        fromCheckoutBlock,
      }
      if (paymentType) {

        paymentAlias = `${paymentType.name}:${paymentType.value}`;
        payloads.paymentAlias = paymentAlias;
      }

      if (typeof props.saveCardSelection != 'undefined' && props.saveCardSelection && (payloads.paymentAlias == "spgw_saferpay_alias_twint:new" || payloads.paymentAlias == "spgw_saferpay_alias_postfinancepay:new")) {
        return {
          type: emitResponse.responseTypes.ERROR,
          message: props.saveCardSelectionErrorMsg,
        };
      }

      const credit_card = document.querySelector(
        'input[name="radio-control-wc-payment-method-options"][value="spgw_credit_card"]'
      );

      if (credit_card !== null) {
        if (credit_card.checked) {
          let tokenCheckReq = true;
          if (paymentType != null && paymentType.value != "" && paymentType.value != "new") {
            tokenCheckReq = false;
          }
          if (tokenCheckReq) {
            const tockenValue = document.getElementById("token");
            if (tockenValue === null || tockenValue.value === '-1') {
              return {
                type: emitResponse.responseTypes.ERROR,
                message: props.credit_params.cardDetailsRequired,
              };
            }
          }


        }
      }

      if (customDataIsValid) {
        payloads.token = token;
      }

      await SaferpayFields.submit({
        onSuccess: function (evt) {
          try {
            const noticesWrapper = document.querySelector(
              ".woocommerce-notices-wrapper"
            );
            if (noticesWrapper) {
              noticesWrapper.innerHTML = "";
            }
            const tokenInput = document.getElementById("token");
            if (tokenInput) {
              tokenInput.value = evt.token;
            }
          } catch (error) {
            console.error("Error handling success callback:", error);
          }
        },
        onError: function (evt) {
          try {
            const noticesWrapper = document.querySelector(
              ".woocommerce-notices-wrapper"
            );
            if (noticesWrapper) {
              noticesWrapper.innerHTML = ""; // Clear notices
            }
          } catch (error) {
            console.error("Error handling error callback:", error);
          }
        },
      });

      return {
        type: emitResponse.responseTypes.SUCCESS,
        meta: {
          paymentMethodData: payloads
        },
      };

    });
    // Unsubscribes when this component is unmounted.
    return () => {
      unsubscribe();
    };
  }, [
    emitResponse.responseTypes.ERROR,
    emitResponse.responseTypes.SUCCESS,
    onPaymentSetup,
  ]);
}
